import { memo, useMemo } from "react";

import ContentCopy from "@mui/icons-material/ContentCopy";
import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";

type CopyPreviousValueAdornmentProps = {
  copyPreviousValues: {
    previousValue?: string | null;
    currentValue?: string | null;
  };
};

const CopyPreviousValueAdornment = ({ copyPreviousValues }: CopyPreviousValueAdornmentProps) => {
  const { t } = useTranslation("common");
  const { previousValue, currentValue } = copyPreviousValues;
  const copyPreviousValueDisabledLook = previousValue === currentValue || !previousValue;
  const tooltipTitle = useMemo(() => {
    if (previousValue === currentValue && previousValue) {
      return t("copy_previous_value_same", { value: previousValue });
    }

    if (previousValue !== currentValue && previousValue) {
      return t("copy_previous_value_of", { value: previousValue });
    }

    return t("copy_previous_value");
  }, [previousValue, currentValue, t]);

  return (
    <Tooltip title={tooltipTitle}>
      <ContentCopy color={copyPreviousValueDisabledLook ? "disabled" : "primary"} sx={{ ml: -1, mr: 0.5 }} />
    </Tooltip>
  );
};

export default memo(CopyPreviousValueAdornment);
